<template>
  <div class="row" id="portfolio">
    <hr />
    <div class="col-12" id="Projects">
      <h4 class="fw-bolder fs-2 mt-5 text-center">Portfolio</h4>
    </div>
    <div class="col-lg-8 col-12">
      <section class="p-5">
        <article>
          <h5 class="fs-4 mb-5 project-spacing">
            Partay - A events planning mobile application
          </h5>
          <img
              src="../assets/imgs/Screenshot_from_2022-09-05_20-34-50.png"
              alt=""
              class="img-fluid box-shadow"
          />
          <div class="fw-light fs-6 font-l mt-5">
            <b class="fw-bold">Key features</b>
            <br /><br />

            This was a contract project for developing from the ground up a events planning application for Android / iOS. The application incorporates several key features which makes publishing and planning events a simple process. Whether the event is today or 1 year from now creating an event is quick and easy. It also features QR codes and event scanning to make sharing and checking into events that much smoother. Try it out.
            <br><br>
            <p>React, React Native, Expo, MySQL, Laravel</p>
            <br /><br />
            <a
                name=""
                id=""
                class="btn btn-primary"
                href="https://play.google.com/store/apps/details?id=com.momsinla.partybemine&hl=en_US&gl=US"
                role="button"
            >Visit site</a
            >
          </div>
        </article>
        <article>
          <h5 class="fs-4 mb-5 project-spacing">
            Importspark IOS Mobile Application
          </h5>
          <img
            src="../assets/imgs/images_projects/Importspark-banner.png"
            alt=""
            class="img-fluid box-shadow"
          />
          <div class="fw-light fs-6 font-l mt-5">
            <b class="fw-bold">Key features</b>
            <br /><br />

            Large collection including metrics and statistics about hand picked
            cars. Socialize and share your own customizable user profile card
            with your friends or the community. Explore and learn about
            community users, and their inspiration stories about their cars.
            <br /><br />
            <a
              name=""
              id=""
              class="btn btn-primary"
              href="http://importspark.samexplains.com"
              role="button"
              >Visit site</a
            >
          </div>
        </article>

        <article>
          <h5 class="fs-4 mb-5 project-spacing">
            Cross Platform Video Player / Shuffler
          </h5>
          <img
            src="../assets/imgs/images_projects/video-shuffler-002.png"
            alt=""
            class="img-fluid box-shadow"
          />
          <div class="fw-light fs-6 font-l mt-5">
            <b class="fw-bold">Key features</b>
            <br /><br />

            Have a large collection of local media files of your favorite shows
            or movies but no way to randomize them? Well me too so I made this
            cross platform Video Player to load in your libraries of videos and
            allow you to play and shuffle them and watch to your enjoyment.
            Simply head over to the repository where you can download and build
            out the project to your designated Operating System. Technologies
            used were Electron, Vue.js and SQLITE3.
            <br /><br />
            <a
              name=""
              id=""
              class="btn btn-primary"
              href="https://github.com/Sampuccino/video-shuffler"
              role="button"
              >Visit repo</a
            >
          </div>
        </article>

        <article v-for="(project, index) in projects" :key="index">
          <h5 class="fs-4 mb-5 project-spacing">
            {{ project.name }}
          </h5>
          <img :src="project.images" alt="" class="img-fluid box-shadow" />
          <div class="fw-light fs-6 font-l mt-5">
            {{ project.description }}

            <br /><br />
            <h6 class="mt-3">Stack</h6>
            <p v-for="(skill, index) in project.languages" :key="index">
              {{ skill }}
            </p>

            <br /><br />
            <a
              v-if="project.link"
              v-bind:href="project.link"
              class="btn btn-primary"
              role="button"
              >Visit site</a
            >
          </div>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      projects: null,
    };
  },
  created() {
    this.projects = [
      {
        name: "Human Reputation Management",
        description:
          "This is a application to rate individuals you meet, encounter or anyone in a Yelp style review system. Say you go eat and you have a polite, wonderful waiter, you can create a profile for that person and basically create a review for that person so other can have an insight on the type of individual they are or how to behaved and reacted when you met them. A majority of the review information is aggregated and averaged out based on all reviews for easy to digest information. It provides analytical insight, they recommendation percentile and the averaged out personality type and score.",
        link: "",
        languages: ["VueJS", "Laravel", "Bootstrap", "UI", "AWS", "ChartJS"],
        images: require("../assets/imgs/images_projects/hyu_1.png"),
      },
      {
        name: "Credit Tracker SPA",
        description:
          "Credit Tracker SPA allows an individual to keep track of their Companies tax credit history along with document storage. Aside from those things, it allows the individual to create and update new companies. While currently just a lightweight dashboard, given the opportunity, it can be expanded to detail other metrics and analytical information. Application was primarily written using the Vue.js framework along with Vuex for state management. To make the UI process faster, a component and UI library were used to mitigate the time spent to write out those components.",
        link: "http://creditracker.us-west-1.elasticbeanstalk.com/",
        url_name: "Credit Tracker SPA demo",
        languages: ["VueJS", "Laravel", "Bootstrap", "UI", "AWS"],
        images: require("../assets/imgs/images_projects/creditracker.png"),
      },
      {
        name: "Interactive IRS Forms",
        description:
          "Don't worry about having to manually fill out and calculate IRS forms. With this easy, simple application, we can handle all of that. Currently only supports IRS Forms 8974, 941 and 941 Schedule B",
        link: "http://irs-8974.us-west-1.elasticbeanstalk.com/",
        url_name: "Click here to try it out",
        languages: ["PHP / Laravel", "VueJS"],
        images: require("../assets/imgs/images_projects/2356505.png"),
      },
      {
        name: "MomsinLA",
        description:
          "MomsinLA is a nonprofit organization with a goal of bridging the cultural differences through community event sharing. Originally conceived as an idea, MomsinLA has became the go to alternative to the companies prior way of keeping in touch with its subscribers but changing the way content is delivered and created for their users. MomsinLA alongside its mobile and web app are the central locations for community event sharing. The vast amount of features including Authentication for a simple easy signup, third party integration like Google, and a unique user experience help make MomsinLA what it is. Registered users are able to create their own events, allow the community to take part in validating those events thus being able to gain points which can be converted to cryptocurrency. The app’s provide many outlets beside community events such as an exchange platform to allow users to share and sell items, advertising, and services information.",
        link: "https://momsinla.com",
        url_name: "https://momsinla.com",
        languages: [
          "PHP / Laravel",
          "MySQL",
          "Firebase / Firestore",
          "UI",
          "RestAPI",
          "AWS [ EC2, EB, S3, RDS ]",
          "OAuth",
        ],
        images: require("../assets/imgs/images_projects/momsinla_app.png"),
      },
      {
        name: "Shiftdown Android App Development & Design",
        description:
          "This is not the final version. This is a companion website to the previously created Shiftdown app for Android. A hobby of mine is to read up on classic import tuner cars or attending events where they are showcasing import JDM cars whether they be tuners, drifting or drag modified. Although I am familiar with a majority of the makes and models there occasionally is a few that slip my mind or I want to get a refresher about the car. So my idea for the app came from having and needing to access all of that information and makes/models as well as other information about the cars in one solid place. So the main idea for the app is to utilize a database in order to store the numerous cars and information about them and allow users to select cars and allow them to view and learn information about each car. That is pretty much the purpose and intention of the app idea, to allow the user to learn more about these fascinating cars. But I won’t be ending it there. I plan on extending its functionality much more. I intend to implement many features such as trivia facts about each car, demo videos and galleries of modified versions of those cars. Aside from that I plan on adding a few big features such as allowing users to register an account which would allow them to create a profile add information about themselves which only registered accounts would be able to do. If users don’t register they will not be able to comment on cars/galleries or create a profile and other few features. My next big feature I plan on doing is implementing a system where registers users can trade their ProfileCar Cards with other users to build out their own collection. This would make a nice fun feature because it would make it seem like you own those cards and you can also view the users profile since they originator of that card will allow people to see. With many of those important features in mind I had came to a fork in the road and a big decision to make . What is stopping me from including other genres or types of racing? Myself included, I was also big on Formula One and LeMans endurance races. So the next greatest feature to this mobile application will include many of our historic cars that have ever graced the streets of LeMans, which will include historical facts, relevant information, many graphics and information to help you cope with the information and much more. I want others to share the similar admiration I have for these cars. Aside from that I may expand the car archives and potentially include motorcyles.",
        link: "//angular-shiftdown.web.app",
        url_name: "shiftdown.web.app",
        languages: ["Java", "MySQL", "UI", "API", "Adobe XD"],
        images: require("../assets/imgs/images_projects/jdm-screen-prot.png"),
      },
      {
        name: "Panacea App",
        description:
          " Social networks have been seeing a tremendous growth over the years. Look online and you can find a community for just about anything. With the rise of health concerns and these internet doctors, many internet users are going to these social health network communities to share and explore their own personal health conditions or learn more about conditions. You may be wonderg what exactly is Panacea ? Panacea is a online social health network where users are required to register, create their medical portfolio and be capable to create their own unique forums threads based on their own personal conditions. The community of other fellow patients and licensed doctors can then go and create responses to an individuals condition based on their knowledge or experience. It is the authority of registered, authenticated physicians to validate the credibility of those replys on the thread and flag threads for the community based on the accuracy of medical information provided. These flags will help mitigate false, inaccurate medical information being spread and create a safer more knowledable community. Some of the key features that were incorporated was.\n" +
          "Key features – RestAPI containing an expansive database of medical conditions, symptoms and recreational activities.\n" +
          "    Personal user dashboards with intuitive graphs, charts and tailored content.\n" +
          "    Privatized medical information only available to authorized physicians with your consent.\n" +
          "    Much more . . .",
        link: "",
        languages: ["PHP / Laravel", "MySQL", "UI", "RestAPI", "Infermedica"],
        images: require("../assets/imgs/images_projects/panacea-dashboard.png"),
      },
      {
        name: "EZBiller Web Application",
        description:
          "For starters the project is a solution not only for my friends business who suffers from having to manually print all of his bills and manage his clients and contacts manually but to anyone out there in the same situation. This whole web application system will be written with PHP with MySQL a bunch of front end technologies and a few backend as well. The whole purpose of the system is to automate the printing billing process by allowing registered users to log in with full authentication and further divide the management through users and admins. Typical users will have far more restricted than average users but it would allow others to print the bills that way eliminating accidental information mishandling. The system will allow the admin to add new customers or edit existing client information add notes about his clients maybe little extra jobs he did here and there and selectively batch print whatever clients he wants and whenever. It will also provide admin dashboards to see monthly income and all other sorts of information. It will also allow users to customize their user name leave comments and change their profile picture and the whole lot. The overall process is to be able to manage all client information in one single place and edit and update even delete customers. It will be a beneficial and beautiful application when finished.",
        link: "",
        languages: ["PHP / Laravel", "MySQL", "UI"],
        images: require("../assets/imgs/images_projects/ezbill-1.png"),
      },
    ];
  },
};
</script>

<style scoped>
#portfolio {
  margin-top: 15rem;
}

section article {
  text-align: left;
}

.btn-primary {
  font-family: "Open Sans Extra Bold";
  background-color: black;
  padding: 1.5rem;
}

.btn-primary:hover {
  background-color: var(--first-color);
}

.project-spacing:nth-child(2n + 1) {
  margin-top: 8rem;
}
</style>